import React, { useState } from "react";
import DatePicker from "../../form/DatePicker";

import { FormField, Label } from "nectar-ui";
import {
  DatePickerActionsContainer,
  DatePickerButton,
  DatePickerCard,
  DatePickerContainer,
  DatePickerErrorText,
  DatePickerRow,
} from "../style";
import { getTargetInput, INITIAL_STATE, validateDateRange } from "./helper";

interface DashboardChartRangeDatePickerProps {
  isOpen: boolean;
  applyDate: (dateRange: any) => void;
  closeDatePicker: () => void;
}

const DashboardChartRangeDatePicker = ({
  isOpen,
  applyDate,
  closeDatePicker,
}: DashboardChartRangeDatePickerProps) => {
  const [dateRange, setDateRange] = useState(INITIAL_STATE.dateRange);
  const [error, setError] = useState(INITIAL_STATE.error);
  const [isFocused, setFocus] = useState(INITIAL_STATE.isFocused);

  const handleSubmit = () => {
    if (error) return;
    applyDate(dateRange);
  };

  const handleUpdateDate = (date: any, whichInput: string) => {
    const targetState = getTargetInput(whichInput);

    setDateRange((prev) => {
      const hasError = validateDateRange({ ...prev, [targetState]: date });
      setError(hasError);

      return { ...prev, [targetState]: date };
    });
  };

  const handleFocusChange = (focused: any, whichInput: string) => {
    const targetState = getTargetInput(whichInput);
    setFocus((prev) => ({ ...prev, [targetState]: focused }));
  };

  if (!isOpen) return null;
  return (
    <DatePickerCard>
      {/* @ts-ignore */}
      <DatePickerContainer shadow="sm" border>
        <DatePickerRow>
          <FormField style={{ width: "100%" }}>
            <Label htmlFor="fromDate">De</Label>
            <DatePicker
              // @ts-ignore
              id="fromDate"
              date={dateRange.fromDate}
              onDateChange={(date: any) => handleUpdateDate(date, "FROM")}
              focused={isFocused.fromDate}
              placeholder=""
              onFocusChange={({ focused }: { focused: boolean }) =>
                handleFocusChange(focused, "FROM")
              }
              validate={error ? "danger" : ""}
              displayFormat="DD/MM/YYYY"
            />
          </FormField>
        </DatePickerRow>
        <DatePickerRow>
          <FormField style={{ width: "100%" }}>
            <Label htmlFor="toDate">Até</Label>
            <DatePicker
              // @ts-ignore
              id="toDate"
              date={dateRange.toDate}
              onDateChange={(date: any) => handleUpdateDate(date, "TO")}
              focused={isFocused.toDate}
              placeholder=""
              onFocusChange={({ focused }: { focused: boolean }) =>
                handleFocusChange(focused, "TO")
              }
              validate={error ? "danger" : ""}
              displayFormat="DD/MM/YYYY"
            />
            {error && (
              <DatePickerErrorText size="sm" color="danger">
                {error}
              </DatePickerErrorText>
            )}
          </FormField>
        </DatePickerRow>
      </DatePickerContainer>
      <DatePickerActionsContainer id="datePicker-actions">
        <DatePickerButton reverse color="default" onClick={closeDatePicker}>
          Cancelar
        </DatePickerButton>
        <DatePickerButton reverse color="primary" disabled={error} onClick={handleSubmit}>
          Aplicar
        </DatePickerButton>
      </DatePickerActionsContainer>
    </DatePickerCard>
  );
};

export default DashboardChartRangeDatePicker;
